export default "__VITE_ASSET__DXB_t$Uk__"